import {Stack} from '@mui/material';
import {ProgressBar, ProgressValue, SectionTitle} from '../profile.styles';

interface Props {
  percent: number;
}

export const DiskUsageSection = ({percent}: Props) => {
  return (
    <Stack gap="12px">
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <SectionTitle>Используемое дисковое пространство</SectionTitle>
        <ProgressValue>{`${percent}%`}</ProgressValue>
      </Stack>
      <ProgressBar variant="determinate" value={percent} />
    </Stack>
  );
};
